import { render, staticRenderFns } from "./joinRecord.vue?vue&type=template&id=a4a4b0ce&scoped=true"
import script from "./joinRecord.vue?vue&type=script&lang=js"
export * from "./joinRecord.vue?vue&type=script&lang=js"
import style0 from "./joinRecord.vue?vue&type=style&index=0&id=a4a4b0ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a4b0ce",
  null
  
)

export default component.exports